/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import s from './StatList.scss';

class StatList extends React.Component {
  render() {
    const { items, heading } = this.props;
    if (items && Array.isArray(items) && items.length > 0) {
      return (
        <div className={s.statList}>
          <h3>{heading}</h3>
          <ul>
            {items &&
              items.map(stat => {
                if (stat?.description) {
                  return (
                    <li>
                      <strong>{stat.hl}</strong>
                      <span>{stat.description}</span>
                    </li>
                  );
                }
                return null;
              })}
          </ul>
        </div>
      );
    }
    return null;
  }
}

StatList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})),
  heading: PropTypes.string,
};

StatList.defaultProps = {
  items: [],
  heading: '',
};

export default StatList;
